import Vue from 'vue'
import './accordions.vue'

export default el => new Vue({
  name: 'Accordions',
  el,
})